// extracted by mini-css-extract-plugin
export var tile = "dataContent-module--tile--a+g6V";
export var colorTile = "dataContent-module--colorTile--gkZcE";
export var text = "dataContent-module--text--9O7Yp";
export var blue = "dataContent-module--blue--B2xzX";
export var orange = "dataContent-module--orange--7ecdI";
export var pink = "dataContent-module--pink--y3vZe";
export var fadeIn = "dataContent-module--fadeIn--MZXHB";
export var slideIn = "dataContent-module--slideIn--cRfO2";